import type { ApiTypes } from "../../../index";
import { axiosInstance, handleApiError } from "../../../utils";

/**
 * cart-country-update operation
 * @param params - Contains path parameters
 * @param request - The request data
 * @returns Promise resolving to the API response
 */
export const updateCartCountry = async ({
  params,
  request,
}: {
  params: ApiTypes["cart-country-update"]["parameters"]["path"];
  request: ApiTypes["cart-country-update"]["request"];
}): Promise<ApiTypes["cart-country-update"]["response"]> => {
  try {
    const response = await axiosInstance.patch<
      ApiTypes["cart-country-update"]["response"]
    >(
      `/api/public/v2025-06/commerce/carts/${params.cart_token}/update_country`,
      request,
    );
    return response.data;
  } catch (error) {
    handleApiError(
      error as Error,
      "Failed to updateCartCountry: ${params.cart_token}",
    );
    throw error;
  }
};
